import * as React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { footerText, fullName, githubUrl } from "../config";
import { useTranslation } from "react-i18next";

const Copyright = () => {
  const { t } = useTranslation();
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      gutterBottom
      sx={{ mb: 2 }}
    >
      {" © "}
      {new Date().getFullYear()}{" "}
      <Link
        color="inherit"
        href={githubUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        {t(`${fullName} - ${footerText}`)}
      </Link>
    </Typography>
  );
};

export default Copyright;
